import { ClipboardAlertOutlineIcon } from './ClipboardAlertOutlineIcon';

/**
 * author: James Coyle
 * id 321F2AC5-C710-4AD5-A493-279435DF0074
 * name clipboard-alert-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-alert-outline.svg
 * tags
 * - Alert / Error 
 */
export const ClipboardWarningOutlineIcon = ClipboardAlertOutlineIcon;
export default ClipboardWarningOutlineIcon